import axios, { AxiosResponse } from 'axios'
import {
  PageResponseHistoricoValorProfissionalList,
  PageResponseValorProfissionalList,
  ValorProfissionalDtoCadastrar,
  ValorProfissionalDtoRemover,
  ValorProfissionalList,
  ValorProfissionalView,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL

const PROFISSIONAL_VALORES_URL = `${API_URL}/financeiro/profissional`
const PROFISSIONAL_HISTORICO_VALORES_URL = `${API_URL}/financeiro/profissional/historico`

/**
 * Busca valores de cliente
 * @param query string
 * @param idProfissional ID do Profissional
 * @returns ValorProfissionalList
 */
export const getValoresProfissional = (
  query: string,
  idProfissional: number
): Promise<PageResponseValorProfissionalList> => {
  return axios
    .get(`${PROFISSIONAL_VALORES_URL}/${idProfissional}?${query}`)
    .then((d: AxiosResponse<PageResponseValorProfissionalList>) => d.data)
}

/**
 * Busca um valor de cliente
 * @param idProfissional ID do Profissional
 * @param idValor ID do valor
 * @returns ValorProfissionalView
 */
export const getValoresProfissionalByValor = (
  idProfissional: number,
  idValor: number
): Promise<ValorProfissionalView> => {
  return axios
    .get(`${PROFISSIONAL_VALORES_URL}/${idProfissional}/${idValor}`)
    .then((d: AxiosResponse<ValorProfissionalView>) => d.data)
}

/**
 * Cadastra valores de cliente
 * @param idProfissional ID do Profissional
 * @param data ValorProfissionalDtoCadastrar
 * @param reprocessarFaturas Recalcula o valor do profissional nos itens das faturas ainda Geradas
 *   (LO-1373). Só vai na query quando verdadeiro: ausente, o backend assume `false`.
 * @returns ValorProfissionalList
 */
export const createValoresByProfissional = (
  idProfissional: number,
  data: ValorProfissionalDtoCadastrar,
  reprocessarFaturas = false
): Promise<ValorProfissionalList> => {
  return axios
    .post(`${PROFISSIONAL_VALORES_URL}/${idProfissional}`, data, {
      params: reprocessarFaturas ? { reprocessarFaturas: true } : undefined,
    })
    .then((d: AxiosResponse<ValorProfissionalList>) => d.data)
}

/**
 * Remove valores de cliente
 * @param idProfissional ID do Profissional
 * @param data ValorProfissionalDtoRemover
 * @returns ValorProfissionalList[]
 */
export const deleteValoresByProfissional = (
  idProfissional: number,
  data: ValorProfissionalDtoRemover
): Promise<ValorProfissionalList[]> => {
  return axios
    .delete(`${PROFISSIONAL_VALORES_URL}/${idProfissional}`, { data })
    .then((d: AxiosResponse<ValorProfissionalList[]>) => d.data)
}

/**
 * Busca histórico de valores
 * @param query string
 * @param idProfissional ID do Profissional
 * @returns HistoricoValorProfissionalList
 */
export const getHistoricoValoresProfissional = (
  query: string,
  idProfissional: number
): Promise<PageResponseHistoricoValorProfissionalList> => {
  return axios
    .get(`${PROFISSIONAL_HISTORICO_VALORES_URL}/${idProfissional}?${query}`)
    .then((d: AxiosResponse<PageResponseHistoricoValorProfissionalList>) => d.data)
}
